function escapeNoteHtml(value: string) {
  return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/'/g, "&#39;");
}

function plainTextToNoteHtml(value: string) {
  return escapeNoteHtml(value).replace(/\r?\n/g, "<br>");
}

export function sanitizeNoteHtml(value: string): string {
  const html = String(value || "");
  if (!html.trim()) return "";
  if (typeof document === "undefined") return escapeNoteHtml(html);
  try {
    // Template contents are inert: even rejected images must never start a request or fire an event.
    const template = document.createElement("template");
    template.innerHTML = html;
    const root = template.content;
    const allowed = new Set(["B", "STRONG", "I", "EM", "U", "S", "STRIKE", "DIV", "P", "BR", "UL", "OL", "LI", "SPAN", "FONT", "BLOCKQUOTE"]);
    Array.from(root.querySelectorAll("*")).forEach((node) => {
      const element = node as HTMLElement;
      const tag = element.tagName.toUpperCase();
      if (["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "SVG", "MATH", "TEMPLATE"].includes(tag)) { element.remove(); return; }
      if (!allowed.has(tag)) {
        const parent = element.parentNode;
        if (!parent) return;
        while (element.firstChild) parent.insertBefore(element.firstChild, element);
        parent.removeChild(element);
        return;
      }
      const colorProbe = document.createElement("span");
      colorProbe.style.color = String(element.getAttribute("color") || element.style.color || "").trim();
      const color = colorProbe.style.color;
      const textAlign = String(element.style.textAlign || "").trim();
      const fontWeight = String(element.style.fontWeight || "").trim();
      const fontStyle = String(element.style.fontStyle || "").trim();
      const textDecoration = String(element.style.textDecoration || element.style.textDecorationLine || "").trim();
      Array.from(element.attributes).forEach((attribute) => element.removeAttribute(attribute.name));
      const safeStyles: string[] = [];
      if (color && !/expression|url\s*\(|javascript:/i.test(color)) safeStyles.push(`color:${color}`);
      if (/^(left|center|right|justify)$/i.test(textAlign)) safeStyles.push(`text-align:${textAlign.toLowerCase()}`);
      if (/^(bold|bolder|[5-9]00)$/i.test(fontWeight)) safeStyles.push(`font-weight:${fontWeight}`);
      if (/^(italic|oblique)$/i.test(fontStyle)) safeStyles.push(`font-style:${fontStyle}`);
      if (/^(underline|line-through|underline line-through|line-through underline)$/i.test(textDecoration)) safeStyles.push(`text-decoration:${textDecoration}`);
      if (safeStyles.length) element.setAttribute("style", safeStyles.join(";"));
    });
    return template.innerHTML;
  } catch {
    return plainTextToNoteHtml(html.replace(new RegExp("\\x3C[^\\x3E]*\\x3E", "g"), ""));
  }
}

